// Dados demo usados quando o Feed está vazio (ainda sem empreendedores publicando)
// IMPORTANTE: estes negócios NÃO existem no banco. Ações (Spark/Curtir) ficam desativadas
// até existirem businesses reais. Eles servem só para mostrar a UX completa.

export const DEMO_BUSINESSES = [
  {
    id: 'demo-1',
    name: 'Cafeteria Beatriz',
    tagline: 'Café especial direto do produtor — quero abrir 2 novas unidades.',
    description:
      'Um espaço aconchegante que valoriza o pequeno produtor brasileiro. Em 2 anos triplicamos o faturamento e queremos levar essa experiência para mais bairros.',
    city: 'São Paulo',
    state: 'SP',
    funding_target: 80000,
    funding_raised: 18000,
    cover_image_url:
      'https://images.unsplash.com/photo-1554118811-1e0d58224f24?auto=format&fit=crop&w=1080&q=80',
    video_url: null,
    tags: ['Gastronomia', 'Café'],
    is_seeking: true,
    owner_id: 'demo-owner-1',
    owner: {
      id: 'demo-owner-1',
      full_name: 'Beatriz Almeida',
      avatar_url:
        'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80',
      location: 'São Paulo, SP',
    },
    created_at: new Date().toISOString(),
    isDemo: true,
  },
  {
    id: 'demo-2',
    name: 'Estúdio Lumen',
    tagline: 'Iluminação artesanal sustentável para a casa do brasileiro.',
    description:
      'Luminárias feitas à mão com madeira de reflorestamento. Já vendemos para 7 estados e queremos automatizar nossa produção.',
    city: 'Curitiba',
    state: 'PR',
    funding_target: 50000,
    funding_raised: 9000,
    cover_image_url:
      'https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?auto=format&fit=crop&w=1080&q=80',
    video_url: null,
    tags: ['Design', 'Sustentabilidade'],
    is_seeking: true,
    owner_id: 'demo-owner-2',
    owner: {
      id: 'demo-owner-2',
      full_name: 'Rafael Tanaka',
      avatar_url:
        'https://images.unsplash.com/photo-1633332755192-727a05c4013d?auto=format&fit=crop&w=200&q=80',
      location: 'Curitiba, PR',
    },
    created_at: new Date().toISOString(),
    isDemo: true,
  },
  {
    id: 'demo-3',
    name: 'Hortinha da Vila',
    tagline: 'Verdura orgânica entregue em 2h, direto da horta urbana.',
    description:
      'Operamos 3 hortas urbanas em SP e entregamos para 200 famílias por semana. Queremos abrir nossa 4ª horta e dobrar a base.',
    city: 'São Paulo',
    state: 'SP',
    funding_target: 120000,
    funding_raised: 35000,
    cover_image_url:
      'https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?auto=format&fit=crop&w=1080&q=80',
    video_url: null,
    tags: ['Agro', 'Orgânico'],
    is_seeking: true,
    owner_id: 'demo-owner-3',
    owner: {
      id: 'demo-owner-3',
      full_name: 'Larissa Mendes',
      avatar_url:
        'https://images.unsplash.com/photo-1607746882042-944635dfe10e?auto=format&fit=crop&w=200&q=80',
      location: 'São Paulo, SP',
    },
    created_at: new Date().toISOString(),
    isDemo: true,
  },
];
